module.exports = __webpack_public_path__ + "static/hab_research_2-f2316081a8579f3f1553889ca889dde6.png";